/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import './krishak.css';
import Select from 'react-select';
import Utilities from '../../global/Utilities';
import ChipsField from '../common/crop/ChipsField';
import AddNumbers from '../common/AddNumbers';
import ApiServices from '../../providers/ApiServices';
import { ADD_KRISHAK_SCREEN, SYNC_SERVICE } from '../../global/Constants';
import SyncServices from '../../providers/SyncServices';

class Prerak extends Component {

    constructor(props) {
        super(props)

        this.state = {
            selectedPoint: null,
            selectedSeed: null,
            selectedDR: null,
            selectedDRs: [],
            selectedInfluenceFactors: [],
            farmerNumbers: [],
            images: [],
            delete_krishak_fellow_farmer_image: [],
            imageFiles: [],
            allDecisionMaking: [],
            allInfluenceFactor: [],
            distributorRetailers: [],
            allKrishakSourceOfInformation: [],
            krishakParam: {},
            fields: {
                fav_tv_show: "",
                fav_radio_show: "",
                fav_newspaper: "",
            },
        }
    }

    componentWillReceiveProps(newProps) {
        if (newProps) {
            let selectedCropGroupIds = newProps.selectedCropGroupIds;

            if (selectedCropGroupIds && selectedCropGroupIds !== undefined && selectedCropGroupIds.length !== 0) {
                Utilities.LogPrint("selectedCropGroupIds", selectedCropGroupIds);
                let is_vc = 0;
                if (selectedCropGroupIds.includes(1) && selectedCropGroupIds.includes(0)) {
                    is_vc = 2;
                } else if (selectedCropGroupIds.includes(1)) {
                    is_vc = 0;
                } else {
                    is_vc = 1;
                }
                this.getAllRetailer(is_vc);
            }
        }
    }

    componentDidMount() {
        this.getKrishakParam();
        let krishakData = this.props.krishakData;
        if (krishakData) {
            //Utilities.LogPrint("updateNextButtonPrerakImages", krishakData);

            let factors = []

            for (var i = 0; i < krishakData.krishak_influence_factors.length; i++) {
                factors.push({
                    value: krishakData.krishak_influence_factors[i].influence_factor_id,
                    label: krishakData.krishak_influence_factors[i].influence_factor_name
                });
            }

            let retailers = [];
            for (var i = 0; i < krishakData.krishak_near_retailers.length; i++) {
                let data = krishakData.krishak_near_retailers[i];
                retailers.push({
                    value: data.retailer_id,
                    label: data.retailer_name + "(" + data.phone + ")"
                });
            }

            this.setState({
                images: (krishakData.krishak_fellow_farmer_images || krishakData.krishak_fellow_farmer_images !== undefined) ? krishakData.krishak_fellow_farmer_images.map(({ image_url: image_url, krishak_fellow_farmer_image_id: id, ...rest }) => ({ image_url, id, ...rest })) : [],
                farmerNumbers: (krishakData.krishak_fellow_farmer_phones || krishakData.krishak_fellow_farmer_phones !== undefined) ? krishakData.krishak_fellow_farmer_phones.map(({ phone: FarmerNumber }) => ({ FarmerNumber })) : [],
                fields: {
                    fav_tv_show: krishakData.favourite_tv,
                    fav_radio_show: krishakData.favourite_radio,
                    fav_newspaper: krishakData.favourite_news,
                },
                // selectedDRs: krishakData.krishak_near_retailers.map(({ retailer_id: value, retailer_name: label, ...rest }) => ({ value, label, ...rest })),
                selectedDRs: retailers,
                selectedInfluenceFactors: factors,
                selectedSeed: {
                    value: krishakData.krishak_source_of_information_id,
                    label: krishakData.krishak_source_of_information_name
                },
                selectedPoint: {
                    value: krishakData.krishak_decision_making_id,
                    label: krishakData.krishak_decision_making_name
                },

            }, () => {
                Utilities.LogPrint("updateNextButtonPrerak123", krishakData.krishak_fellow_farmer_phones);
                this.updateNextButton();
            })
        }
    }

    _getFieldValue(fieldName, defaultValue) {
        const { fields } = this.state;
        let value = fields[fieldName];
        if (value === null || typeof value === "undefined") {
            value = defaultValue;
        }
        return value;
    }

    _handleValueChange = (field, e) => {
        let fields = this.state.fields;
        fields[field] = e.target.value;
        this.setState({ fields });
        this.updateNextButton();
    };

    updateNextButton = () => {

        const { selectedSeed, delete_krishak_fellow_farmer_image, farmerNumbers, images, imageFiles, selectedPoint, selectedDRs, selectedInfluenceFactors } = this.state;

        // let isEnable = selectedSeed !== null && selectedDRs.length !== 0 && selectedInfluenceFactors.length !== 0;
        let isEnable = selectedSeed !== null && selectedInfluenceFactors.length !== 0;
        const fav_tv_show = this._getFieldValue("fav_tv_show", "");
        const fav_radio_show = this._getFieldValue("fav_radio_show", "");
        const fav_newspaper = this._getFieldValue("fav_newspaper", "");

        let mobileImages = [];
        Utilities.LogPrint("prerakImage", images);
        if (images !== undefined) {
            for (var i = 0; i < images.length; i++) {
                let image1 = images[i];
                mobileImages.push({
                    image_url: (image1.image_url === undefined) ? image1.path : image1.image_url,
                    image_name: (image1.image_name === undefined) ? Math.random().toString(36).substring(7) : image1.image_name
                });
            }
        }


        if (isEnable) {

            var prerak = {
                source_of_information: selectedSeed,
                decision_making: selectedPoint,
                nearest_dr: selectedDRs,
                factors_influence_purchase: selectedInfluenceFactors,
                fav_tv_show: fav_tv_show,
                fav_radio_show: fav_radio_show,
                fav_newspaper: fav_newspaper,
                farmer_mobile_numbers: farmerNumbers.length !== 0 ? ((farmerNumbers[0].FarmerNumber !== undefined) ? farmerNumbers.map(({ FarmerNumber: phone }) => ({ phone })) : farmerNumbers) : [],
                farmer_mobile_images: mobileImages,
                farmer_mobile_images_files: imageFiles,
                delete_krishak_fellow_farmer_image
            };
        }

        Utilities.LogPrint("_handleNextButtonPrerak", prerak);

        this.props._handleNextButton(isEnable, prerak, "prerak");
    }

    getKrishakParam = () => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_INFLUENCE_FACTOR, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data && data !== undefined && data.length > 0) {
                this.setState({
                    allInfluenceFactor: data,
                });
            }
        });

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_KRISHAK_SOURCE_OF_INFORMATION, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data && data !== undefined && data.length > 0) {
                this.setState({
                    allKrishakSourceOfInformation: data.map(({ krishak_source_of_information_id: value, name: label, ...rest }) => ({ value, label, ...rest }))
                });
            }
        });

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_KRISHAK_DECISION_MAKING, SYNC_SERVICE.MASTER_TABLE).then(data => {
            if (data && data !== undefined && data.length > 0) {
                this.setState({
                    allDecisionMaking: data.map(({ krishak_decision_making_id: value, name: label, ...rest }) => ({ value, label, ...rest })),
                });
            }
        });

        // this.props.loaderCallback(true);
        // try {
        //     ApiServices.getKrishakParam().then(response => {
        //         var status = response.success;
        //         if (status) {
        //             const krishakParam = response.data;
        //             this.setState({
        //                 allInfluenceFactor: krishakParam.influence_factor,
        //                 allDecisionMaking: krishakParam.krishak_decision_making.map(({ krishak_decision_making_id: value, name: label, ...rest }) => ({ value, label, ...rest })),
        //                 allKrishakSourceOfInformation: krishakParam.krishak_source_of_information.map(({ krishak_source_of_information_id: value, name: label, ...rest }) => ({ value, label, ...rest }))
        //             })
        //             this.props.loaderCallback(false);
        //             Utilities.LogPrint("getKrishakParam", krishakParam);
        //         } else {
        //             Utilities.LogPrint("getKrishakParam", response);
        //             this.props.loaderCallback(false);
        //         }
        //     }).catch(error => {
        //         this.props.loaderCallback(false);
        //         Utilities.LogPrint("getKrishakParam", error);
        //     });
        // } catch (error) {
        //     this.props.loaderCallback(false);
        //     Utilities.LogPrint("getKrishakParam", error);
        // }
    }

    getAllRetailer = (is_vc) => {

        SyncServices.getDataFromDatabase(SYNC_SERVICE.ACTION_RETAILER, SYNC_SERVICE.MASTER_TABLE).then(data => {
            //Utilities.LogPrint("Retailers", data);
            if (data && data !== undefined && data.length > 0) {
                let retailers = [];
                for (var i = 0; i < data.length; i++) {
                    let data1 = data[i];
                    if (is_vc !== 2) {
                        if (is_vc === data1.is_vc) {
                            retailers.push({
                                value: data1.retailer_id,
                                label: data1.retailer_name + "(" + data1.phone + ")"
                            });
                        }
                    } else {
                        retailers.push({
                            value: data1.retailer_id,
                            label: data1.retailer_name + "(" + data1.phone + ")"
                        });
                    }
                }
                this.setState({
                    distributorRetailers: retailers
                });
            }
        });

        // this.props.loaderCallback(true);
        // var body = JSON.stringify({
        //     page: 1,
        //     perPage: 10,
        //     searchKey: "",
        //     sortBy: "created_at",
        //     sortOrder: "DESC"
        // });
        // try {
        //     ApiServices.getAllRetailer(body).then(response => {
        //         var status = response.success;
        //         if (status) {
        //             let retailers = [];
        //             for (var i = 0; i < response.data.data.length; i++) {
        //                 let data = response.data.data[i];
        //                 retailers.push({
        //                     value: data.retailer_id,
        //                     label: data.retailer_name + "(" + data.phone + ")"
        //                 });
        //             }
        //             const newArrayOfObj = retailers;
        //             this.setState({ distributorRetailers: newArrayOfObj })
        //             Utilities.LogPrint("distributorRetailers", this.state.distributorRetailers);
        //         } else {
        //             Utilities.LogPrint("distributorRetailers", response);
        //         }
        //         this.props.loaderCallback(false);
        //     }).catch(error => {
        //         this.props.loaderCallback(false);
        //         Utilities.LogPrint("distributorRetailers", error);
        //     });
        // } catch (error) {
        //     this.props.loaderCallback(false);
        //     Utilities.LogPrint("distributorRetailers", error);
        // }
    }

    handleDRClick = (e, dr) => {
        // e.preventDefault();
        const newArray = this.state.selectedDRs.slice(); // Create a copy

        var index = newArray.indexOf(dr)
        if (index !== -1) {
            newArray.splice(index, 1);
        }

        this.setState({ selectedDRs: newArray }, () => {
            this.updateNextButton();
        });
        Utilities.LogPrint("selectedDR", newArray.length);
    }

    handleNumbers = (numbers) => {
        this.setState({ farmerNumbers: numbers }, () => {
            this.updateNextButton();
        });
    }

    handleNumberImages = (images, files) => {
        this.setState({ images, imageFiles: files }, () => {
            this.updateNextButton();
        });
    }

    handlePointChange = selectedPoint => {
        this.setState({ selectedPoint }, () => {
            this.updateNextButton();
        });
    };

    onInfluenceFactorChange = (event) => {
        let value = event.target.value;
        let name = event.target.name;
        const newArray = this.state.selectedInfluenceFactors.slice(); // Create a copy

        if (newArray.some(e => e.value == value)) {
            /* selectedCrops contains the element we're looking for */
            let index = -1;
            for (var i = 0; i < newArray.length; i++) {
                if (newArray[i].value == value) {
                    index = i;
                }
            }

            // var index = newArray.indexOf(value)
            if (index !== -1) {
                newArray.splice(index, 1);
            }
        } else {
            newArray.push({
                value: parseInt(value),
                label: name
            });
        }
        this.setState({ selectedInfluenceFactors: newArray }, () => {
            this.updateNextButton();
            Utilities.LogPrint("selectedInfluenceFactors", newArray);
        });
    }

    deleteFellowFarmerImageApi = (item) => {
        if (item.id !== 0) {
            let delete_krishak_fellow_farmer_image = this.state.delete_krishak_fellow_farmer_image.slice();
            delete_krishak_fellow_farmer_image.push(item.id);
            this.setState({
                delete_krishak_fellow_farmer_image
            })
        }
        var params = JSON.stringify({
            krishak_fellow_farmer_image_id: item.id,
        });
        try {
            ApiServices.deleteKrishakFellowFarmerImage(params)
                .then(response => {
                    var status = response.success
                    if (status) {
                        Utilities.LogPrint("deleteFellowFarmerImageApi", response.message);
                    }
                    else {
                        this.setState({ isLoading: false });
                    }
                })
                .catch(error => {
                    Utilities.LogPrint("deleteFellowFarmerImageApi-catch", error);
                });
        }
        catch (error) {
            Utilities.LogPrint("deleteFellowFarmerImageApi-error", error);
        }
    }

    handleSeedChange = selectedSeed => {
        this.setState({ selectedSeed }, () => {
            this.updateNextButton();
        });
    };

    handleDRChange = selectedDR => {

        const newArray = this.state.selectedDRs.slice(); // Create a copy


        if (newArray.some(e => e.value === selectedDR.value)) {
            /* selectedCrops contains the element we're looking for */
            var index = newArray.indexOf(selectedDR)
            if (index !== -1) {
                newArray.splice(index, 1);
            }
        } else {
            newArray.push(selectedDR);
        }
        this.setState({ selectedDRs: newArray }, () => {
            this.updateNextButton();
        });
        Utilities.LogPrint("selectedDRs", newArray.length);
    };


    render() {

        const { isVisible } = this.props;
        const fav_tv_show = this._getFieldValue("fav_tv_show", "");
        const fav_radio_show = this._getFieldValue("fav_radio_show", "");
        const fav_newspaper = this._getFieldValue("fav_newspaper", "");
        const { allKrishakSourceOfInformation, images, farmerNumbers, distributorRetailers, selectedInfluenceFactors, allInfluenceFactor, allDecisionMaking, selectedSeed, selectedPoint, selectedDR, selectedDRs } = this.state;

        const allInfluenceFactorListItem = allInfluenceFactor.map((factor, i) =>
        (selectedInfluenceFactors.some(e => e.value === factor.influence_factor_id) ? <div id={i} className="col-lg-3 col-6 mt-md-3" key={i}>
            <div className="form-group">
                <label className="cutom-checkbox-container">
                    {factor.name}
                    <input type="checkbox" checked onChange={this.onInfluenceFactorChange} value={factor.influence_factor_id} name={factor.name} />
                    <span className="checkmark"></span>
                </label>
            </div>
        </div>
            :
            <div id={i} className="col-lg-3 col-6 mt-md-3" key={i}>
                <div className="form-group">
                    <label className="cutom-checkbox-container">
                        {factor.name}
                        <input type="checkbox" onChange={this.onInfluenceFactorChange} value={factor.influence_factor_id} name={factor.name} />
                        <span className="checkmark"></span>
                    </label>
                </div>
            </div>)
        );

        const selectedDRItem = selectedDRs.map((distributorRetailer, i) =>
            <ChipsField distributorRetailer={distributorRetailer} key={i} handleDRClick={this.handleDRClick} />
        );

        return (
            <div className={isVisible ? "row krishak-tab-body prerak-body" : "row krishak-tab-body prerak-body d-none"}>
                {/* <div className="col-12"> */}
                <div className="col-lg-5 col-12">
                    <div className="form-group">
                        <label className="font-weight-medium">{ADD_KRISHAK_SCREEN.SOURCE_INFORMATION_SEEDS} *</label>

                        <Select className="mb-3 max-w-360"
                            value={selectedSeed}
                            onChange={this.handleSeedChange}
                            options={allKrishakSourceOfInformation}
                            placeholder={ADD_KRISHAK_SCREEN.SELECT_ANY_ONE}
                            isClearable={true}
                        />
                    </div>
                </div>
                <div className="col-lg-5 col-12">
                    <div className="form-group d-none-mob">
                        <label className="font-weight-medium d-block">{ADD_KRISHAK_SCREEN.NEAREST_AGRI_DISTRIBUTOR_RETAILER}</label>
                        <Select className=" max-w-360"
                            value={selectedDR}
                            onChange={this.handleDRChange}
                            options={distributorRetailers}
                            placeholder={ADD_KRISHAK_SCREEN.SELECT_ONE_OR_MULTIPLE}
                            isClearable={true}
                        />
                        <div className="col-12 p-0 mt-3 ">
                            <div className="pills-list mb-3 d-none-mob desktop">
                                <ul>
                                    {selectedDRItem}

                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-12 d-md-none">
                    <label className="font-weight-medium mt-md-3">{ADD_KRISHAK_SCREEN.NEAREST_AGRI_DISTRIBUTOR_RETAILER}</label>
                    <Select className=" max-w-360"
                        value={selectedDR}
                        onChange={this.handleDRChange}
                        options={distributorRetailers}
                        placeholder={ADD_KRISHAK_SCREEN.SELECT_ONE_OR_MULTIPLE}
                        isClearable={true}
                    />
                    <div className="pills-list mb-3">
                        <ul>
                            {selectedDRItem}
                        </ul>
                    </div>
                </div>
                <div className="col-12">
                    <div className="form-group">
                        <label className="font-weight-medium">{ADD_KRISHAK_SCREEN.FACTORS_INFLUENCING_PURCHASE_INTENTION} *</label>
                        <div className="row">
                            {allInfluenceFactorListItem}
                        </div>
                    </div>
                </div>

                <div className="col-12">
                    <div className="row">
                        <div className="col-lg-5">
                            <div className="form-group">
                                <label className="font-weight-medium">{ADD_KRISHAK_SCREEN.POINTS_OF_DECISION_MAKING}</label>
                                <Select className="mb-3 max-w-360"
                                    value={selectedPoint}
                                    onChange={this.handlePointChange}
                                    options={allDecisionMaking}
                                    placeholder={ADD_KRISHAK_SCREEN.SELECT_ANY_ONE}
                                    isClearable={true}
                                />
                            </div>
                        </div>
                        <div className="col-lg-5">

                            <div className="form-group">
                                <label className="font-weight-medium">{ADD_KRISHAK_SCREEN.FAVOURITE_TV_SHOW}</label>
                                <input type="text" className="form-control max-w-360" value={fav_tv_show} placeholder={ADD_KRISHAK_SCREEN.TYPE_HERE} onChange={this._handleValueChange.bind(this, "fav_tv_show")} />
                            </div>
                        </div>

                        <div className="col-lg-5">

                            <div className="form-group">
                                <label className="font-weight-medium">{ADD_KRISHAK_SCREEN.FAVOURITE_RADIO_SHOW}</label>
                                <input type="text" className="form-control max-w-360" value={fav_radio_show} placeholder={ADD_KRISHAK_SCREEN.TYPE_HERE} onChange={this._handleValueChange.bind(this, "fav_radio_show")} />
                            </div>
                        </div>
                        <div className="col-lg-5">

                            <div className="form-group">
                                <label className="font-weight-medium">{ADD_KRISHAK_SCREEN.FAVOURITE_NEWSPAPER}</label>
                                <input type="text" className="form-control max-w-360" value={fav_newspaper} placeholder={ADD_KRISHAK_SCREEN.TYPE_HERE} onChange={this._handleValueChange.bind(this, "fav_newspaper")} />
                            </div>
                        </div>
                        <div className="col-lg-12">

                            <AddNumbers onDeleteImageApi={this.deleteFellowFarmerImageApi} images={images} farmerNumbers={farmerNumbers} onAddNumber={this.handleNumbers} onAddNumberImages={this.handleNumberImages} />
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}

export default Prerak
